import React from 'react'
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/Endpoint";
import NACell from "../Reusable/DataTable/NACell";
// import TableSettingLayout from "../Reusable/DataTable/TableSettingLayout";
import { useNavigate } from "react-router-dom";
import ResetIcon from "../../Icons/ResetIcon";

const ColumnDefinitionList = () => {
  const navigate = useNavigate();
  
const handleRowClick = (row: any) => {
  const id = row.original.id;
    const slug = row.original.slug;
    navigate(`${slug}/edit/${id}`);
    
  };

  const defaultColumns = [
 {
      header: "Name",
      accessorKey: "name",
      cell: NACell
    },
 {
    header: "Slug",
    accessorKey: "slug",
    cell: (props: any) => (
      <div className="whitespace-nowrap">
        <NACell {...props} />
      </div>
    ),
  },
    
  ];
  return (
    <DataTable
      url={APIS.COLUMN_DEFINITION_RESET}
      queryKey="column-definitions"
      columns={defaultColumns}
      params={{}}
      addNewPagePath="/columndefinitionlist/create"
      tableName={"columndefinition"}
      onRowClick={handleRowClick}
    />
  );
}

export default ColumnDefinitionList